import { Store } from "./store.model";

export interface Version {
    ClientKey?: string;
    Id: string;
    VersionName: string;
    Disclaimer?: string;
    stores: Store[];
    selected?: boolean;
    storesCount?: number; 
    storePageIndex?: number;
    isLoading?: boolean;
    hasError?: boolean;
}
